import { useCallback, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { clsx } from 'clsx';
import type { CarouselV2Props, CarouselApi } from './types';
import styles from './CarouselV2.module.scss';

export const CarouselV2 = ({
  children,
  className,
  classes,
  onSlideChange,
  getCarouselApi,
  ...rest
}: CarouselV2Props) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(rest);

  const slidesInView = useCallback((api: CarouselApi) => {
    onSlideChange(api.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!getCarouselApi) return;
    getCarouselApi(emblaApi);
  }, [emblaApi]);

  useEffect(() => {
    if (!onSlideChange) return;
    if (emblaApi && onSlideChange) {
      emblaApi.on('slidesInView', slidesInView);
    }
    return () => {
      if (emblaApi && onSlideChange) {
        emblaApi.off('slidesInView', slidesInView);
      }
    };
  }, [emblaApi, slidesInView]);

  return (
    <div ref={emblaRef} className={clsx(styles.embla, className)}>
      <div className={clsx(styles.emblaContainer, classes?.container)}>
        {children}
      </div>
    </div>
  );
};

CarouselV2.displayName = 'CarouselV2';

CarouselV2.defaultProps = {
  align: 'start',
  containScroll: 'trimSnaps',
  slidesToScroll: 1,
};
